import { useHistory } from "react-router-dom";
import { Layout } from "../../../shared/components/Layout";
import { FormTaxRate } from "../components/FormTaxRate";
import {
  PATH_TAX_WITHHOLDINGS,
  PATH_TAX_WITHHOLDINGS_EDIT_TAX_PROFILE
} from "../paths";

export const RouteEditTaxRate = () => {
  const history = useHistory();

  return (
    <Layout title="Tax Withholdings">
      <FormTaxRate
        onEditTaxProfile={() => {
          history.push(PATH_TAX_WITHHOLDINGS_EDIT_TAX_PROFILE);
        }}
        onBack={() => {
          history.push(PATH_TAX_WITHHOLDINGS);
        }}
        onNext={() => {
          history.push(PATH_TAX_WITHHOLDINGS);
        }}
        isEdit
      />
    </Layout>
  );
};
